import { EventEmitter } from "eventemitter3";
import IDObject from "./IDObject";
/**
 * EventEmitterをmixinしたIDObject
 */
class EEObject extends IDObject {
    constructor() {
        super();
        EventEmitter.call(this);
    }
}
function applyMixins(derivedCtor, baseCtors) {
    baseCtors.forEach((baseCtor) => {
        Object.getOwnPropertyNames(baseCtor.prototype).forEach((name) => {
            derivedCtor.prototype[name] = baseCtor.prototype[name];
        });
    });
}
applyMixins(EEObject, [EventEmitter]);
export default EEObject;



// WEBPACK FOOTER //
// ./src/Base/EEObject.ts